module.exports = __webpack_public_path__ + "static/img/ls3.14d2bba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/ls3.png
// module id = kOOx
// module chunks = 12